<template>
    <transition name="fade">
        <div class="container">
            <div class="league-create-link-wrapper">
                <i class="white-medal-ico icon-white-medal"></i>
                <h2 class="league-create-link">
                    <Loading :loadingState="nameLoadingState">{{localLigaName}}</Loading>
                </h2>
                <p class="league-create-link-p">
                Jedinstveni link za tvoju ligu je:
                </p>
                <a :href="joinLigaUrl" class="unique-league-link">
                {{ joinLigaUrl }}
                </a>
                <ul class="socials" v-if="false">
                    <li><a href="#" class="face icon-face" ></a></li>
                    <li><a href="#" class="wapp icon-wapp" ></a></li>
                    <li><a href="#" class="viber icon-viber" ></a></li>
                    <li><a href="#" class="blank icon-chain" ></a></li>
                    <li><a href="#" class="blank icon-mail-3" ></a></li>
                </ul>
            </div>
            <a href="#" @click.prevent="deleteUserLiga()" class="button-1 red">
                <span>Obriši svoju ligu</span>
            </a>
        </div>
    </transition>
</template>

<script>
import Loading from '../common/Loading'
import LoadingState from '../../utils/loading/LoadingState'
import { getPublicPath } from '../../utils/getPublicPath'

export default {
    name: 'kreirajligulink',
    data () {
        return {
            nameLoadingState: LoadingState.Loading,
            localLigaName: null,
            deletingUserLiga: false
        }
    },
    props: {
        ligaId: null,
        ligaName: null
    },
    components: {
        Loading
    },
    async mounted () {
        if (!this.ligaNameProp) {
            try {
                this.localLigaName = await this.$db.lige.getLigaName(this.ligaId)
                this.nameLoadingState = LoadingState.SUCCESS
            } catch (error) {
                this.nameLoadingState = LoadingState.ERROR
            }
        } else {
            this.nameLoadingState = LoadingState.SUCCESS
        }
    },
    methods: {
        async deleteUserLiga () {
            if (!this.deletingUserLiga) {
                this.deletingUserLiga = true
                try {
                    let data = await this.$db.lige.deleteUserLiga({ ligaId: this.ligaId })
                    if (data.success) {
                        this.$emit('deleted', true)
                    }
                } catch (error) {
                    console.error(error)
                }
                this.deletingUserLiga = false
            }
        }
    },
    watch: {
        ligaName (after) {
            if (after) {
                this.localLigaName = after
            }
        }
    },
    computed: {
        currentUrl () {
            var protocol = location.protocol
            var slashes = protocol.concat('//')
            var host = slashes.concat(window.location.host)
            return host
        },
        joinLigaUrl () {
            let publicPath = getPublicPath()
            return `${this.currentUrl}${publicPath}/liga/${this.ligaId}`
        },
        ligaNameProp () {
            if (this.ligaName) {
                return this.ligaName
            } else {
                return false
            }
        }
    }
}
</script>

<style lang="scss" scoped>
.unique-league-link {
    transition: color .4s ease-in-out;

    &:hover  {
        color: #0a2c4d;
    }
}
</style>
